import classes from './SessionList.module.css'
import useBotsService from '../../../../services/bot/botService';
import SessionItem from './SessionItem/SessionItem';

function SessionList() {
    const botService = useBotsService()
    const currentSession = botService.getCurrentSession()

    return (
        <div className={classes.SessionList}>
            {botService.getAllSessions().map((s,i) => {
                return (<SessionItem key={s.id} id={s.id} name={s.name} lastUpdated={s.lastUpdated} selected={currentSession == s.id}/>)
            })
            }
        </div>
    );
}

export default SessionList;
